import { Collapse as bsCollapse } from 'bootstrap';

const url = location.href.replace(/\/$/, "");

class SmartCollapseTrigger {

    constructor(el) {
        this.el = el;
        this.contentId = el.getAttribute('aria-labelledby');
        if(this.contentId != null) {
            // is open already?
            let bsShow = this.el.classList.contains('show');
            // open if anchor is in page url
            if (location.hash) {
                let hash = url.split("#")[1];
                if(hash.length > 0) {
                    if(hash == this.contentId) bsShow = true;
                }
            }
            let options = {hide:true, toggle: false};
            this.bsCollapse = bsCollapse.getOrCreateInstance(this.el, options);
            if(bsShow) this.bsCollapse.show();
            // find any links to this collapse and expand if they're clicked.
            let findLinks = document.querySelectorAll(`[href="#${this.contentId}"]`);
            if(findLinks != null) {
                findLinks.forEach(l => {
                    l.addEventListener('click',() => {
                        setTimeout(() => {
                            this.bsCollapse.show();
                        }, 500);
                    });
                });
            }
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {

    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new SmartCollapseTrigger(node);
        }
    });

}